import { ModeloEtiqueta } from './../../model/geral/modeloEtiqueta';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModeloEtiquetaService extends GenericService<ModeloEtiqueta>{
  constructor(http: HttpClient) { 
    super(http);
    super.initResource("modeloetiqueta")
  }

  // Método para chamar o endpoint de consulta com o filtro de idTabela
  getModeloEtiquetaByTabela(idTabela: string): Observable<ModeloEtiqueta[]> {
    const url = `${this.url}/consulta?idTabela=${idTabela}`;
    return this.http.get<ModeloEtiqueta[]>(url);
  }
}
